import React from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';

function AutoLoadInput({ ...rest }) {
  return <Autocomplete {...rest} />;
}

export default AutoLoadInput;
